<template>
  <div class="pbx-menu-item">
    <div :class="['pbx-menu-box', `pbx-menu-box--${type}`]">
      <div class="pbx-menu-box__content">
        <img :src="`/img/icons/pbx/action-types/${type}.svg`" alt="" />
      </div>
    </div>

    <p class="pbx-menu-item__title">
      {{ $t(`autoinformer.worksheets.actions.${type}`) }}
    </p>
  </div>
</template>
<script>
  export default {
    props: {
      type: {
        type: String,
        required: true
      }
    }
  };
</script>

<style lang="scss">
  .sidebar-worksheet__content--autoinformer {
    .pbx-menu-item__title {
      text-align: center;
      margin-top: 10px;
      color: $text-color;
      font-size: 14px;
      font-weight: 700;
    }

    .pbx-menu-box {
      width: 82px;
      height: 82px;
      border-radius: 100%;
      border: 4px solid #ddd;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto;

      @each $type, $color in $pbx-action-types {
        &--#{$type} {
          border-color: $color;
        }
      }

      &--postback {
        > div {
          padding-left: 3px;
          padding-top: 5px;
        }
      }

      &__content {
        background: #fff;
        width: 60px;
        height: 60px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15), 4px 4px 4px 0 rgba(0, 0, 0, 0.15);
      }
    }
  }
</style>
